import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ReportScheduleSchema = withDefaults({
  type: 'report-schedule',
  fields: [
    {
      kind: 'attribute',
      name: 'reportId',
    },
    {
      kind: 'attribute',
      name: 'companyId',
    },
    {
      kind: 'attribute',
      name: 'frequency',
    },
    {
      kind: 'attribute',
      name: 'dateValue',
    },
    {
      kind: 'attribute',
      name: 'runHourUtc',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'pausedReason',
    },
    {
      kind: 'attribute',
      name: 'recipientEmployeeIds',
    },
    {
      kind: 'attribute',
      name: 'createdBy',
    },
    {
      kind: 'attribute',
      name: 'updatedBy',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
  ],
});

export default ReportScheduleSchema;
